module.exports = __webpack_public_path__ + "img/Saba.f8a1855a.png";